import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { TDealsState } from '../../types'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseDeals } from './utils'
import { selectors } from './selectors'
import { dealsAdapter } from './adapter'

const name = 'deals'

const initialState: TDealsState = {
    ...dealsAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseDeals(await moneyFlowService.fetchDeals())
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                dealsAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const deals = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}